<script setup lang="ts">
import { ref } from "vue";
import { useAppStore } from "@/stores/app";

const appStore = useAppStore();

interface Props {
    openActive?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    openActive: false,
});

let active = ref(props.openActive);

function toggleMenu() {
    appStore.navigation.slideout.visible = !appStore.navigation.slideout.visible;
}
</script>

<template>
    <button class="hamburger-wrapper flex items-center select-none" @click="toggleMenu">
        <div class="hamburger-button" :class="{ active: active }">
            <span :class="appStore.navigation.slideout.visible ? 'bg-brown-200' : appStore.navigation.header.sticky ? 'bg-brown-200' : 'bg-brown-200'"></span>
            <span :class="appStore.navigation.slideout.visible ? 'bg-brown-200' : appStore.navigation.header.sticky ? 'bg-brown-200' : 'bg-brown-200'"></span>
            <span :class="appStore.navigation.slideout.visible ? 'bg-brown-200' : appStore.navigation.header.sticky ? 'bg-brown-200' : 'bg-brown-200'"></span>
            <span :class="appStore.navigation.slideout.visible ? 'bg-brown-200' : appStore.navigation.header.sticky ? 'bg-brown-200' : 'bg-brown-200'"></span>
        </div>
    </button>
</template>

<style>
.hamburger-button {
    width: 16px;
    height: 16px;
    overflow: hidden;
    flex-flow: column;
    justify-content: space-between;
    transition: height 0.2s;
    z-index: 200;
    display: flex;
}

.hamburger-button span {
    height: 2px;
    width: 16px;
    border-radius: 1px;
    display: flex;
    transition: all 0.2s;
    transform-origin: left;
    align-self: flex-start;
}

.hamburger-button span.active span:nth-child(1) {
    transform: rotate(45deg);
}
.hamburger-button span.active span:nth-child(2) {
    opacity: 0;
}
.hamburger-button span.active span:nth-child(3) {
    transform: translateY(2px) rotate(-45deg);
}
</style>
